<template>

  <div class="elevation-2 search-box white" v-if="searching">
    <v-toolbar flat="flat">
      <v-toolbar-title class="search-title">Search</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon class="search-bt"
              title="Hide the search"
              @click="closeSearch">mdi-magnify-close</v-icon>
    </v-toolbar>
    <v-container fluid="fluid" grid-list-md="grid-list-md">
      <v-layout class="my-3" row="row" wrap="wrap">

        <!-- NAME -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-4">
          <v-text-field class="field"
                        v-model="searchParams.name"
                        label="Name"
                        placeholder="Name"></v-text-field>
        </v-flex>

        <!-- SPORT -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <SportSelector ref="sportSelector"
                         :currentSportIDs="searchParams.sportID"
                         @sportSelected="sportSelected"/>
        </v-flex>

        <!-- TYPE -->
        <v-flex d-flex="d-flex" xs12="xs12" sm12="sm12" md6="md6" class="px-5">
          <ClubTypeSelector ref="typeSelector"
                            :currentType="searchParams.type"
                            @typeSelected="typeSelected"/>
        </v-flex>

      </v-layout>
      <v-layout row="row" wrap="wrap">
        <v-spacer></v-spacer>
        <v-btn class="search-action" :small="true" color="primary" flat="flat" @click.native="clearSearch">Clear</v-btn>
        <v-btn class="search-action" :small="true" color="primary" @click.native="search">Search</v-btn>
      </v-layout>
    </v-container>
  </div>

</template>

<script>

import SportSelector from '../common/SportSelector'
import ClubTypeSelector from '../common/ClubTypeSelector'

export default {
  name: 'Search',
  components: {
    SportSelector,
    ClubTypeSelector
  },
  props: ['searching'],
  data () {
    return {
      searchParams: {
        name: '',
        sportID: '',
        type: ''
      }
    }
  },
  methods: {
    search () {
      if (!this.searchParams.name) {
        delete this.searchParams.name
      }
      if (!this.searchParams.sportID) {
        delete this.searchParams.sportID
      }
      if (!this.searchParams.type) {
        delete this.searchParams.type
      }

      this.$emit('search', this.searchParams)
    },

    clearSearch () {
      this.$refs.sportSelector.clear()
      this.$refs.typeSelector.clear()

      this.searchParams = {
        name: '',
        sportID: '',
        type: ''
      }
      this.$emit('clearSearch')
    },

    closeSearch () {
      this.$emit('closeSearch')
    },

    sportSelected (sportid) {
      this.searchParams.sportID = sportid
    },
    typeSelected (type) {
      this.searchParams.type = type
    }
  }
}

</script>

<style lang="scss" scoped>

  .search-box {
    margin-bottom: 30px;
  }

  .search-title {
    font-size: 1rem;
    font-weight: 700;
  }

  .field {
    margin: 0 24px;
  }

</style>



// WEBPACK FOOTER //
// src/components/clubs/Search.vue